<div class="container-fluid">
  <div class="card">
    <div class="d-flex">
      <div class="no-p-767">
        <div class="card-smaller card">
          <div class="d-flex justify-content-between">
            <div>
              <div class="circle-blue">
                <span class="circle-blue-icon"><i class="far fa-warehouse-alt"></i></span>
              </div>
            </div>
            <div class="d-flex flex-column align-items-start available-primary">
              <div class="available-number" data-cy="quantity-stock">
                {{ getQuantityStock() }}
              </div>
              <div class="available-amount">
                {{ 'totalInStock' | translate }}
              </div>
            </div>
            <div class="d-flex" *ngIf="product.quantityPurchase > 0">
              <div class="d-flex flex-column align-items-start">
                <div class="available-number" data-cy="quantity-stock">
                  +{{ product.quantityPurchase * getPackPiecesIfInPack() }}
                </div>
                <div class="available-amount">
                  {{ 'totalOnTheWay' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex mb-3 no-p-767">
        <form-row-toggle
          class="align-self-center"
          [label]="'isShowingNullPositions'"
          [(model)]="isShowingNullStock"
          [classesString]="'text-nowrap'"
        ></form-row-toggle>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!stock || (stock && stock.length === 0)" class="text-center">
  {{ 'no.record.found' | translate }}
</div>

<div *ngIf="stock && stock.length > 0">
  <div *ngFor="let pDepot of stock">
    <div class="card d-flex">
      <div class="d-flex padding-left-1-rem gap-2 mb-3">
        <h2 class="mb-0 align-self-center card-title text-nowrap" [title]="'quantityStock' | translate">
          {{ pDepot.depot ? pDepot.depot.name : pDepot.depot.name }}
        </h2>
        <div class="d-flex align-items-center">
          <div class="d-flex text-nowrap align-items-center">
            <div
              class="depot-quantity-container"
              [ngClass]="isQuantityUnderMinimum(pDepot) ? 'yellow-background' : 'bg-white border-black'"
            >
              <div *ngIf="!isQuantityUnderMinimum(pDepot)" class="warehouse-icon">
                <i class="far fa-warehouse-alt"></i>
              </div>
              <button
                *ngIf="isQuantityUnderMinimum(pDepot)"
                type="button"
                class="btn d-flex"
                tooltip="{{ 'product-depots.form.supplies.under-min' | translate }}"
                placement="right"
                containerClass="under-min-icon"
              >
                <img src="../../../../assets/img/icons/icon-product-under-min.svg" alt="login image" />
              </button>

              <div class="d-flex align-items-center">
                <div class="font-weight-bold" [ngClass]="isQuantityUnderMinimum(pDepot) ? 'yellow' : ''">
                  {{ pDepot.sumAll + ' ' + ('piece' | translate) }}
                </div>
              </div>
            </div>
          </div>
          <div class="ml-3">
            <app-modal-product-depot-metric
              [productPack]="productDetailService.productPack"
              [product]="product"
              [depot]="pDepot.depot"
              [readonly]="!productDetailService.hasRoleUpdateMetrics"
            ></app-modal-product-depot-metric>
          </div>
        </div>
      </div>

      <div class="d-flex grey-text" *ngIf="!hasPDepotItemsToShow(pDepot)">
        <p class="padding-left-1-rem">{{ 'products.no-goods' | translate }}</p>
      </div>
      <div class="table-responsive" *ngIf="hasPDepotItemsToShow(pDepot)">
        <table class="table m-0">
          <thead>
            <tr>
              <th class="text-left pl-0 pt-0">
                {{ 'supplier' | translate }}
              </th>
              <ng-container *ngIf="product.enabledBatchExpiration">
                <th>{{ 'product.batch' | translate }}</th>
                <th>{{ 'product.expirationDate' | translate }}</th>
              </ng-container>
              <th class="text-center" *ngIf="arePositionsEnabled">{{ 'position' | translate }}</th>
              <th class="text-right text-nowrap">{{ 'purchasePrice' | translate }}</th>
              <th class="text-center pt-0">
                <div class="flex-direction-column-gap-20">
                  <div>
                    {{ 'stock' | translate }}
                  </div>
                </div>
              </th>
              <th class="text-nowrap d-none d-xl-table-cell">&nbsp;</th>
              <th class="text-left">{{ 'lastChange' | translate }}</th>
              <th class="fixed-column-width">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let depot of pDepot.items">
              <ng-template [ngIf]="depot.quantityStock > 0 || isShowingNullStock">
                <tr>
                  <td class="pl-1 text-nowrap">
                    {{ depot.supplier ? depot.supplier.name : '' }}
                  </td>
                  <ng-container *ngIf="product.enabledBatchExpiration">
                    <td class="text-nowrap">
                      {{ depot.batch }}
                    </td>
                    <td>
                      <span *ngIf="depot.expirationDate">{{ depot.expirationDate | fmtDate: 'dd.MM.yyyy' }}</span>
                    </td>
                  </ng-container>
                  <td class="text-center text-nowrap" *ngIf="arePositionsEnabled && depot.position">
                    {{ depot.position }}
                  </td>
                  <td class="text-right text-nowrap">
                    {{ depot.purchasePrice | formatPrice: product.purchaseCurrency }}
                  </td>
                  <td class="text-center text-nowrap">
                    <span>{{ depot.quantityStock.toFixed(2) }}</span>
                  </td>
                  <td class="text-right text-nowrap no-hover fixed">
                    <button
                      *ngIf="isProductDepotExpired(depot)"
                      type="button"
                      class="btn d-flex"
                      tooltip="{{ 'product-depots.form.after-expiration' | translate }}"
                      placement="left"
                      containerClass="expired-icon"
                    >
                      <img src="../../../../assets/img/icons/icon-expired-product.svg" alt="login image" />
                    </button>
                  </td>
                  <td class="text-left text-nowrap">
                    {{ depot.updated | date: 'dd.MM.yyyy HH:mm' }}
                  </td>
                  <td>
                    <div class="flex-gap-5 align-items-center">
                      <modal-stock-load
                        [product]="product"
                        [depots]="depots"
                        [suppliers]="suppliers"
                        [currencies]="currencies"
                        [isUnloadingStock]="true"
                        [currentStockItem]="depot"
                        [btnXs]="true"
                        (result)="modalStockResult(depot)"
                        *ngIf="productDetailService.hasStockOperationOutRole"
                      ></modal-stock-load>
                      <modal-stock-load
                        [product]="product"
                        [depots]="depots"
                        [suppliers]="suppliers"
                        [currencies]="currencies"
                        [isUnloadingStock]="false"
                        [currentStockItem]="depot"
                        [btnXs]="true"
                        (result)="modalStockResult(depot)"
                        *ngIf="productDetailService.hasStockOperationInRole"
                      ></modal-stock-load>
                      <modal-stock-positions
                        [productDepot]="depot"
                        [suppliers]="suppliers"
                        [btnXs]="true"
                        [stock]="pDepot"
                        [product]="product"
                        (result)="modalStockResult(depot)"
                        *ngIf="productDetailService.hasUpdateRole"
                      ></modal-stock-positions>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="table-responsive" *ngIf="hasPDepotPurchaseOrderItemsToShow(pDepot)">
        <div class="on-the-way-title">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
              <path
                d="M21.45 12.9375H20.9V8.85586C20.9 8.18789 20.6353 7.5375 20.1747 7.06641L17.2906 4.1168C16.83 3.6457 16.1906 3.375 15.5409 3.375H14.3V1.96875C14.3 0.882422 13.4372 0 12.375 0H4.125C3.06281 0 2.2 0.882422 2.2 1.96875V3.375H0.275C0.12375 3.375 0 3.50156 0 3.65625V4.21875C0 4.37344 0.12375 4.5 0.275 4.5H8.525C8.67625 4.5 8.8 4.37344 8.8 4.21875V3.65625C8.8 3.50156 8.67625 3.375 8.525 3.375H3.85V1.96875C3.85 1.81406 3.97375 1.6875 4.125 1.6875H12.375C12.5263 1.6875 12.65 1.81406 12.65 1.96875V12.9375H8.34281C7.77219 11.932 6.72031 11.25 5.5 11.25C4.895 11.25 4.33813 11.4293 3.85 11.7176V10.125H2.2V14.625C2.2 16.4883 3.67812 18 5.5 18C7.32188 18 8.8 16.4883 8.8 14.625H13.2C13.2 16.4883 14.6781 18 16.5 18C18.3219 18 19.8 16.4883 19.8 14.625H21.45C21.7525 14.625 22 14.3719 22 14.0625V13.5C22 13.1906 21.7525 12.9375 21.45 12.9375ZM5.5 16.3125C4.58906 16.3125 3.85 15.5566 3.85 14.625C3.85 13.6934 4.58906 12.9375 5.5 12.9375C6.41094 12.9375 7.15 13.6934 7.15 14.625C7.15 15.5566 6.41094 16.3125 5.5 16.3125ZM14.3 5.0625H15.5409C15.7575 5.0625 15.9706 5.15391 16.1253 5.30859L18.6347 7.875H14.3V5.0625ZM16.5 16.3125C15.5891 16.3125 14.85 15.5566 14.85 14.625C14.85 13.6934 15.5891 12.9375 16.5 12.9375C17.4109 12.9375 18.15 13.6934 18.15 14.625C18.15 15.5566 17.4109 16.3125 16.5 16.3125ZM19.25 12.7652C18.6588 11.8547 17.6481 11.25 16.5 11.25C15.6509 11.25 14.8844 11.5875 14.3 12.1254V9.5625H19.25V12.7652ZM8.8 8.71875V8.15625C8.8 8.00156 8.67625 7.875 8.525 7.875H0.275C0.12375 7.875 0 8.00156 0 8.15625V8.71875C0 8.87344 0.12375 9 0.275 9H8.525C8.67625 9 8.8 8.87344 8.8 8.71875ZM9.625 6.75C9.77625 6.75 9.9 6.62344 9.9 6.46875V5.90625C9.9 5.75156 9.77625 5.625 9.625 5.625H1.375C1.22375 5.625 1.1 5.75156 1.1 5.90625V6.46875C1.1 6.62344 1.22375 6.75 1.375 6.75H9.625Z"
                fill="#ED1C24"
              />
            </svg>
            {{ 'on.the.way' | translate }}
          </span>
        </div>
        <table class="table m-0">
          <thead>
            <tr>
              <th class="text-left pl-0 pt-0">
                {{ 'purchaseOrder.externalReference' | translate }}
              </th>
              <th class="text-left pl-0 pt-0">
                {{ 'supplier' | translate }}
              </th>
              <th class="text-center">{{ 'quantity' | translate }}</th>
              <th class="text-right text-nowrap">{{ 'purchasePrice' | translate }}</th>
              <th class="text-right text-nowrap">{{ 'order.date' | translate }}</th>
              <th class="text-right">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let poItem of pDepot.purchaseOrderItems">
              <tr>
                <td class="pl-1 text-nowrap">
                  <a [routerLink]="['/purchase-order', poItem.purchaseOrder.id]">
                    {{ poItem.purchaseOrder ? poItem.purchaseOrder.externalReference : '' }}
                  </a>
                </td>
                <td class="pl-1 text-nowrap">
                  {{ poItem.purchaseOrder.supplier ? poItem.purchaseOrder.supplier.name : '' }}
                </td>
                <td class="text-center text-nowrap">
                  {{ ((poItem.quantity - poItem.quantityIn) * getPackPiecesIfInPack()).toFixed(2) }}
                </td>
                <td class="text-right text-nowrap">
                  {{ poItem.purchasePrice | formatPrice: product.purchaseCurrency }}
                </td>
                <td class="text-right text-nowrap">
                  {{ poItem.purchaseOrder.created | date: 'dd.MM.yyyy HH:mm' }}
                </td>
                <td>
                  <div class="flex-gap-5 align-items-center justify-content-end">
                    <a
                      *ngIf="poItem?.purchaseOrder?.supplier?.externalId !== 'henryschein'"
                      [routerLink]="['/purchase-order', poItem.purchaseOrder.id]"
                      class="btn btn-second"
                    >
                      {{ 'purchase-orders.detail' | translate }}
                      <i class="far fa-chevron-right ml-2"></i>
                    </a>
                    <a
                      *ngIf="poItem?.purchaseOrder?.supplier?.externalId === 'henryschein'"
                      [routerLink]="['/purchase-order-hs', poItem.purchaseOrder.id]"
                      class="btn btn-second"
                    >
                      {{ 'purchase-orders.detail' | translate }}
                      <i class="far fa-chevron-right ml-2"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
